// src/components/Admin/ManageCategories.jsx
import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function ManageCategories() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState('');

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await api.get('/categories');
      setCategories(res.data);
    } catch (err) {
      alert('Failed to load categories');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    try {
      await api.post('/categories', { name });
      setName('');
      fetchCategories();
    } catch (err) {
      alert('Failed to create category');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this category?')) return;
    try {
      await api.delete(`/categories/${id}`);
      fetchCategories();
    } catch (err) {
      alert('Failed to delete');
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-6">Manage Categories</h2>

      {/* Add Category */}
      <form onSubmit={handleSubmit} className="bg-gray-50 p-4 rounded mb-6">
        <input
          type="text"
          placeholder="Category Name (e.g., Sports Games)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="p-2 border rounded flex-1 mr-2"
        />
        <button type="submit" className="btn btn-primary">
          Add Category
        </button>
      </form>

      {/* List */}
      <div className="space-y-2">
        {categories.map(cat => (
          <div key={cat.id} className="flex justify-between items-center p-3 bg-white border rounded">
            <span className="font-medium">{cat.name}</span>
            <button
              onClick={() => handleDelete(cat.id)}
              className="text-red-500 hover:text-red-700 text-sm"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}